import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

export const Route = createFileRoute("/_site/services/business-plan-writing")({
  // Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "Business Plan Writing",
      description:
        "Investor and lender-grade business plans with financial models built to withstand underwriting.",
      path: "/services/business-plan-writing",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return (
    <PagePlaceholder title={"Business plan writing"} intro={"[SUPPLY: service detail copy]"} />
  );
}
